var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,43.921569%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 20 7.222656 C 12.953125 7.222656 7.222656 12.953125 7.222656 20 C 7.222656 27.046875 12.953125 32.777344 20 32.777344 C 27.046875 32.777344 32.777344 27.046875 32.777344 20 C 32.777344 12.953125 27.046875 7.222656 20 7.222656 Z M 20 7.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 58.999219 36 C 58.999219 48.705469 48.705469 58.999219 36 58.999219 C 23.294531 58.999219 13.000781 48.705469 13.000781 36 C 13.000781 23.294531 23.294531 13.000781 36 13.000781 C 48.705469 13.000781 58.999219 23.294531 58.999219 36 Z M 58.999219 36 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 27.998437 45.998437 C 29.580469 43.439062 32.90625 41.864062 36.421875 41.997656 C 39.649219 42.117187 42.560156 43.657031 44.001562 45.998437 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.667969 18.292969 C 16.667969 19.210938 15.917969 19.957031 15 19.957031 C 14.082031 19.957031 13.332031 19.210938 13.332031 18.292969 C 13.332031 17.371094 14.082031 16.625 15 16.625 C 15.917969 16.625 16.667969 17.371094 16.667969 18.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.667969 18.292969 C 26.667969 19.210938 25.917969 19.957031 25 19.957031 C 24.082031 19.957031 23.332031 19.210938 23.332031 18.292969 C 23.332031 17.371094 24.082031 16.625 25 16.625 C 25.917969 16.625 26.667969 17.371094 26.667969 18.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 22.999219 23.997656 L 30.002344 27.998437 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 49.000781 23.997656 L 41.997656 27.998437 ",
    transform: "matrix(0.555556,0,0,0.555556,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.26bba9b10bc9b8e821c513d95bd48521.svg";
export { ForwardRef as ReactComponent };